import React from 'react';
import { Route } from 'react-router';

import {
  LoadablePayments,
  LoadablePrivacy,
  LoadableRefunds,
  LoadableTerms,
  LoadablePage,
} from './helpers/loadables';

// Route configuration
// Read more https://github.com/ReactTraining/react-router/tree/v3.2.1/docs
export default (
  <>
    {/* Static pages */}
    <Route component={LoadablePage}>
      <Route path="payments" component={LoadablePayments} />
      <Route path="privacy" component={LoadablePrivacy} />
      <Route path="refunds" component={LoadableRefunds} />
      <Route path="terms" component={LoadableTerms} />
    </Route>
  </>
);
